<now-wbsuche-lib-unterrichtsform-basis-facette
  [id]="'vorort'"
  [label]="'Lernen vor Ort'"
  [modalId]="'praesenzveranstaltungen'"
></now-wbsuche-lib-unterrichtsform-basis-facette>
